import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
let kejianrouter = new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: () => import('./views/ceshihome.vue'),
            hidden: true, // 是否隐藏
            redirect: 'home', // 默认进入
            meta: {title: '系统首页'},
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: () => import('./views/Home.vue'),
                    // meta: {title: '系统首页'},
                },
                /*{
                    path: '/dataList',
                    name: 'dataList',
                    component: () => import('./views/routerView.vue'),
                    meta: {title: '列表'},
                    hidden: true, // 是否隐藏
                    redirect: 'list', // 默认进入
                    children: [
                        {
                            path: '/list',
                            name: 'list',
                            component: () => import('./views/dataList/list.vue'),
                        }, {
                            path: '/details',
                            name: 'details',
                            component: () => import('./views/dataList/details.vue'),
                            meta: {title: '详情'},
                        },
                    ]
                }, */
                {
                    path: '/search',
                    name: 'search',
                    component: () => import('./views/routerView'),
                    meta: {title: '搜索'},
                    redirect: '/search/search', // 默认进入
                    children: [
                        {
                            path: 'search',
                            name: 'search',
                            component: () => import('./views/search'),
                            meta: {title: '搜索'}
                        }, {
                            path: 'details',
                            name: 'details',
                            component: () => import('./views/dataList/details.vue'),
                            meta: {title: '搜索详情'}
                        },
                    ]
                },
                {
                    path: '/userCenter',
                    name: 'userCenter',
                    component: () => import('./views/routerView'),
                    meta: {title: '用户中心'},
                    hidden: true, // 是否隐藏
                    redirect: '/userCenter/memberCenter', // 默认进入
                    children: [
                        {
                            path: 'memberCenter',
                            name: 'memberCenter',
                            component: () => import('./views/userCenter/memberCenter/index.vue'),
                            meta: {title: '会员中心'},
                        }, {
                            path: 'myRegistration',
                            name: 'myRegistration',
                            component: () => import('./views/userCenter/myRegistration/index.vue'),
                            meta: {title: '我的报名'},
                        }, {
                            path: 'myGrades',
                            name: 'myGrades',
                            component: () => import('./views/userCenter/myGrades/index.vue'),
                            meta: {title: '我的成绩'},
                        }, {
                            path: 'myCertificate',
                            name: 'myCertificate',
                            component: () => import('./views/examinationAndRegistration/certificateQuery/index.vue'),
                            meta: {title: '我的证书'},
                        }, {
                            path: 'myCollection',
                            name: 'myCollection',
                            component: () => import('./views/userCenter/myCollection/index.vue'),
                            meta: {title: '我的收藏'},
                        }, {
                            path: 'personalData',
                            name: 'personalData',
                            component: () => import('./views/userCenter/personalData/index.vue'),
                            meta: {title: '个人资料'},
                        }, {
                            path: 'passwordSecurity',
                            name: 'passwordSecurity',
                            component: () => import('./views/userCenter/passwordSecurity/index.vue'),
                            meta: {title: '密码安全'},
                        }, {
                            path: 'logOut',
                            name: 'logOut',
                            component: () => import('./views/userCenter/passwordSecurity/index.vue'),
                            meta: {title: '退出登录'},
                        },
                    ]
                },
                {
                    path: '/examinationAndRegistration',
                    name: 'examinationAndRegistration',
                    component: () => import('./views/routerView'),
                    meta: {title: '考试与报名'},
                    hidden: true, // 是否隐藏
                    redirect: '/examinationAndRegistration/introduce', // 默认进入
                    children: [
                        {
                            path: 'introduce',
                            name: 'introduce',
                            component: () => import('./views/examinationAndRegistration/introduce/index.vue'),
                            meta: {title: '考试介绍'},
                        },  {
                            path: 'outline',
                            name: 'outline',
                            component: () => import('./views/examinationAndRegistration/outline/index.vue'),
                            meta: {title: '考试大纲'},
                        }, {
                            path: 'signUp',
                            name: 'signUp',
                            component: () => import('./views/examinationAndRegistration/signUp/index.vue'),
                            meta: {title: '考试报名'},
                        }, {
                            path: 'scoreInquiry',
                            name: 'scoreInquiry',
                            component: () => import('./views/examinationAndRegistration/scoreInquiry/index.vue'),
                            meta: {title: '成绩查询'},
                        },{
                            path: 'certificateQuery',
                            name: 'certificateQuery',
                            component: () => import('./views/examinationAndRegistration/certificateQuery/index.vue'),
                            meta: {title: '证书查询'},
                        }, {
                            path: 'testSiteQuery',
                            name: 'testSiteQuery',
                            component: () => import('./views/examinationAndRegistration/testSiteQuery/index.vue'),
                            meta: {title: '考点查询'},
                        },
                    ]
                },
                {
                    path: '/latestNews',
                    name: 'latestNews',
                    component: () => import('./views/routerView'),
                    meta: {title: '最新资讯'},
                    hidden: true, // 是否隐藏
                    redirect: '/latestNews/examNotice', // 默认进入
                    children: [
                        {
                            path: 'examNotice',
                            name: 'examNotice',
                            component: () => import('./views/routerView'),
                            meta: {title: '考试通知'},
                            redirect: '/latestNews/examNotice/list', // 默认进入
                            children: [
                                {
                                    path: 'list',
                                    name: 'list',
                                    component: () => import('./views/latestNews/examNotice/list.vue'),
                                    meta: {title: '列表'}
                                }, {
                                    path: 'details',
                                    name: 'details',
                                    component: () => import('./views/dataList/details.vue'),
                                    meta: {title: '详情'}
                                },
                            ]
                        },
                        {
                            path: 'newsInformation',
                            name: 'newsInformation',
                            component: () => import('./views/routerView'),
                            meta: {title: '新闻资讯'},
                            redirect: '/latestNews/newsInformation/list', // 默认进入
                            children: [
                                {
                                    path: 'list',
                                    name: 'list',
                                    component: () => import('./views/latestNews/newsInformation/list.vue'),
                                    meta: {title: '列表'}
                                }, {
                                    path: 'details',
                                    name: 'details',
                                    component: () => import('./views/dataList/details.vue'),
                                    meta: {title: '详情'}
                                },
                            ]
                        },
                        {
                            path: 'testSiteInformation',
                            name: 'testSiteInformation',
                            component: () => import('./views/routerView'),
                            meta: {title: '活动公告'},
                            redirect: '/latestNews/testSiteInformation/list', // 默认进入
                            children: [
                                {
                                    path: 'list',
                                    name: 'list',
                                    component: () => import('./views/latestNews/testSiteInformation/list.vue'),
                                    meta: {title: '列表'}
                                }, {
                                    path: 'details',
                                    name: 'details',
                                    component: () => import('./views/dataList/details.vue'),
                                    meta: {title: '详情'}
                                },
                            ]
                        },
                        {
                            path: 'lecture',
                            name: 'lecture',
                            component: () => import('./views/routerView'),
                            meta: {title: '学术交流'},
                            redirect: '/latestNews/lecture/list', // 默认进入
                            children: [
                                {
                                    path: 'list',
                                    name: 'list',
                                    component: () => import('./views/latestNews/lecture/list.vue'),
                                    meta: {title: '列表'}
                                }, {
                                    path: 'details',
                                    name: 'details',
                                    component: () => import('./views/dataList/details.vue'),
                                    meta: {title: '详情'}
                                },
                            ]
                        },
                        /*{
                            path: 'cooperation',
                            name: 'cooperation',
                            component: () => import('./views/routerView'),
                            meta: {title: '国际合作'},
                            redirect: '/latestNews/cooperation/list', // 默认进入
                            children: [
                                {
                                    path: 'list',
                                    name: 'list',
                                    component: () => import('./views/latestNews/cooperation/list.vue'),
                                    meta: {title: '列表'}
                                }, {
                                    path: 'details',
                                    name: 'details',
                                    component: () => import('./views/dataList/details.vue'),
                                    meta: {title: '详情'}
                                },
                            ]
                        },*/
                    ]
                },
                {//实习实践
                    path: '/internship',
                    name: 'internship',
                    component: () => import('./views/routerView'),
                    meta: {title: '实习实践'},
                    hidden: true, // 是否隐藏
                    redirect: '/internship/overseasInternship', // 默认进入
                    children: [
                        {
                            path: 'overseasInternship',
                            name: 'overseasInternship',
                            component: () => import('./views/routerView'),
                            meta: {title: '实习实践项目'},
                            redirect: '/internship/overseasInternship/list', // 默认进入
                            children: [
                                {
                                    path: 'list',
                                    name: 'list',
                                    component: () => import('./views/internship/overseasInternship/list.vue'),
                                    meta: {title: '列表'}
                                }, {
                                    path: 'details',
                                    name: 'details',
                                    component: () => import('./views/dataList/details.vue'),
                                    meta: {title: '详情'}
                                },
                            ]
                        }, {
                            path: 'internationalChinese',
                            name: 'internationalChinese',
                            component: () => import('./views/routerView'),
                            meta: {title: '实习实践动态'},
                            redirect: '/internship/internationalChinese/list', // 默认进入
                            children: [
                                {
                                    path: 'list',
                                    name: 'list',
                                    component: () => import('./views/internship/internationalChinese/list.vue'),
                                },
                                {
                                    path: 'details',
                                    name: 'details',
                                    component: () => import('./views/dataList/details.vue'),
                                    meta: {title: '详情'}
                                },
                            ]
                        }, {
                            path: 'employment',
                            name: 'employment',
                            component: () => import('./views/routerView'),
                            meta: {title: '就业及升学'},
                            redirect: '/internship/employment/list', // 默认进入
                            children: [
                                {
                                    path: 'list',
                                    name: 'list',
                                    component: () => import('./views/internship/employment/list.vue'),
                                },
                                {
                                    path: 'details',
                                    name: 'details',
                                    component: () => import('./views/dataList/details.vue'),
                                    meta: {title: '详情'}
                                },
                            ]
                        },
                    ]
                },
                {
                    path: '/resourceCenter',
                    name: 'resourceCenter',
                    component: () => import('./views/routerView'),
                    meta: {title: '资源中心'},
                    hidden: true, // 是否隐藏
                    redirect: '/resourceCenter/textbook', // 默认进入
                    children: [
                        {
                            path: 'textbook',
                            name: 'textbook',
                            component: () => import('./views/routerView'),
                            meta: {title: '教材教辅'},
                            redirect: '/resourceCenter/textbook/list', // 默认进入
                            children: [
                                {
                                    path: 'list',
                                    name: 'list',
                                    component: () => import('./views/resourceCenter/textbook/list.vue'),
                                    meta: {title: '列表'}
                                }, {
                                    path: 'details',
                                    name: 'details',
                                    component: () => import('./views/dataList/details.vue'),
                                    meta: {title: '详情'}
                                },
                            ]
                        },
                        {
                            path: 'freeCourse',
                            name: 'freeCourse',
                            component: () => import('./views/routerView'),
                            meta: {title: '免费课程'},
                            redirect: '/resourceCenter/freeCourse/list', // 默认进入
                            children: [
                                {
                                    path: 'list',
                                    name: 'list',
                                    component: () => import('./views/resourceCenter/freeCourse/list.vue'),
                                    meta: {title: '列表'}
                                }, {
                                    path: 'details',
                                    name: 'details',
                                    component: () => import('./views/dataList/details.vue'),
                                    meta: {title: '详情'}
                                },
                            ]
                        },
                        {
                            path: 'examSample',
                            name: 'examSample',
                            component: () => import('./views/routerView'),
                            meta: {title: '考试样题'},
                            redirect: '/resourceCenter/examSample/list', // 默认进入
                            children: [
                                {
                                    path: 'list',
                                    name: 'list',
                                    component: () => import('./views/resourceCenter/examSample/list.vue'),
                                    meta: {title: '列表'}
                                }, {
                                    path: 'details',
                                    name: 'details',
                                    component: () => import('./views/dataList/details.vue'),
                                    meta: {title: '详情'}
                                },
                            ]
                        },
                        {
                            path: 'addition',
                            name: 'addition',
                            component: () => import('./views/routerView'),
                            meta: {title: '加试说明'},
                            redirect: '/resourceCenter/addition/list', // 默认进入
                            children: [
                                {
                                    path: 'list',
                                    name: 'list',
                                    component: () => import('./views/resourceCenter/addition/list.vue'),
                                    meta: {title: '列表'}
                                }, {
                                    path: 'details',
                                    name: 'details',
                                    component: () => import('./views/dataList/details.vue'),
                                    meta: {title: '详情'}
                                },
                            ]
                        },
                    ]
                },
                {
                    path: '/aboutUs',
                    name: 'aboutUs',
                    component: () => import('./views/routerView'),
                    meta: {title: '关于我们'},
                    hidden: true, // 是否隐藏
                    redirect: '/aboutUs/platformIntroduction', // 默认进入
                    children: [
                        {
                            path: 'platformIntroduction',
                            name: 'platformIntroduction',
                            component: () => import('./views/aboutUs/platformIntroduction/index.vue'),
                            meta: {title: '主办机构'}
                        },
                        {
                            path: 'contactUs',
                            name: 'contactUs',
                            component: () => import('./views/aboutUs/contactUs/index.vue'),
                            meta: {title: '联系我们'}
                        },
                        {
                            path: 'examPoint',
                            name: 'examPoint',
                            component: () => import('./views/aboutUs/examPoint/index.vue'),
                            meta: {title: '考点申请'}
                        },
                        {
                            path: 'copyright',
                            name: 'copyright',
                            component: () => import('./views/aboutUs/copyright/index.vue'),
                            meta: {title: '版权申明'}
                        },
                        {
                            path: 'memberTerms',
                            name: 'memberTerms',
                            component: () => import('./views/aboutUs/memberTerms/index.vue'),
                            meta: {title: '会员条款'}
                        },
                        {
                            path: 'complaint',
                            name: 'complaint',
                            component: () => import('./views/aboutUs/complaint/index.vue'),
                            meta: {title: '投诉建议'}
                        },
                    ]
                },
            ]
        },
        {
            path: '/login',
            name: '登录',
            component: () => import('./views/Login.vue')
        }, {
            path: '/shenfenxinxi',
            name: '证书信息',
            component: () => import('./views/shenfenxinxi/index.vue')
        },
    ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
    // 判断是否需要登录权限
    if (to.matched.some(res => res.meta.requireAuth)) {
        // 判断是否登录
        if (sessionStorage.getItem('token')) {
            next()
        } else {
            // 没登录则跳转到登录界面
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    } else {
        next()
    }
})

export default kejianrouter
